import $ from "jquery";

function initCategoryNav() {

  $(".js-category-nav__link--toggle").click(function () {
    var isVisible = $(
      ".category-nav__link:not(.category-nav__link--toggle)",
    ).is(":visible");
    $(".category-nav__link:not(.category-nav__link--toggle)").slideToggle();
    $(this).attr("aria-expanded", !isVisible);
  });
}

$(document).ready(initCategoryNav);
